export const canada = ['NB', 'NL', 'NS', 'PE', 'ON', 'PQ', 'AB', 'BC', 'MB', 'SK'];
export const mexico = ['Aguascalientes',
    'Baja California Norte',
    'Baja California Sur',
    'Campeche',
    'Chiapas',
    'Chihuahua',
    'Coahuila',
    'Colima',
    'Distrito Federale',
    'Durango',
    'Estado Mexico',
    'Guanajuato',
    'Guerrero',
    'Hidalgo',
    'Jalisco',
    'Michoacan',
    'Morelos',
    'Nayarit',
    'Nuevo Leon',
    'Oaxaca',
    'Puebla',
    'Queretaro',
    'Quintana Roo',
    'San Luis Potos',
    'Sinaloa',
    'Sonora',
    'Tabasco',
    'Tamaulipas',
    'Tlaxcala',
    'Veracruz Llave',
    'Yucatan',
    'Zacatecas'
].map(s => s.substring(0, Math.min(s.length, 14)));
export const trashStates = ['WA', 'OR', 'UT', 'CA', 'ID', 'SD', 'ND', 'WY'];
export const usa = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];
export const zones = ['Z0', 'Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7', 'Z8', 'Z9', 'ZM', 'ZW', 'ZC', 'ZE'];
export const zoneMappings = {
    'Z0': ['CT', 'ME', 'MA', 'NH', 'NJ', 'RI', 'VT'],
    'Z1': ['DE', 'NY', 'PA'],
    'Z2': ['MD', 'NC', 'SC', 'VA', 'WV'],
    'Z3': ['AL', 'FL', 'GA', 'MS', 'TN'],
    'Z4': ['IN', 'KY', 'MI', 'OH'],
    'Z5': ['IA', 'MN', 'MT', 'ND', 'SD', 'WI'],
    'Z6': ['IL', 'KS', 'MO', 'NE'],
    'Z7': ['AR', 'LA', 'OK', 'TX'],
    'Z8': ['AZ', 'CO', 'ID', 'NV', 'NM', 'UT', 'WY'],
    'Z9': ['CA', 'OR', 'AK', 'WA'],
    'ZE': ['NB', 'NL', 'NS', 'PE'],
    'ZC': ['ON', 'QC'],
    'ZW': ['AB', 'BC', 'MB', 'SK'],
};
export const allStates = [...canada, ...usa];
export const allStatesAndZones = [...allStates, ...zones];
export function isState(area) {
    return allStates.includes(area);
}
